<template>
    <div id="credencial">
        <div class="credencial">
            <div class="nav">
                <div class="nav-logo">
                    <img v-if="logoGimnasioUrl" :src="logoGimnasioUrl" alt="Logo" class="logo-img" />
                    <div v-else class="logo-placeholder">{{ (nombreGimnasio || 'G').charAt(0) }}</div>
                </div>
                <div class="nav-info">
                    <b class="gym-name">{{ nombreGimnasio }}</b>
                    <p class="gym-contact">Tel: {{ telefonoGimnasio }}</p>
                    <p class="gym-contact">{{ direccionGimnasio }}</p>
                </div>
            </div>
            <p class="nombre">{{ miembro.nombre }}</p>
            <p class="matricula">{{ miembro.matricula }}</p>
            <img class="imagen" :src="urlImagen(miembro.imagen)" alt="Foto" />
            <p class="dato"><span>Tel:</span> {{ miembro.telefono }}</p>
            <p class="dato"><span>Dir:</span> {{ miembro.direccion }}</p>
            <p class="dato"><span>Desde:</span> {{ miembro.fechaRegistro }}</p>
            <!-- QR en el frente de la credencial -->
            <div class="qr-area">
                <img id="qr-credencial-img" src="" width="90" height="90" style="border:2px solid #1706FF;border-radius:6px" />
                <p class="qr-label">Escanear para registrar entrada</p>
            </div>
        </div>
        <div class="credencial credencial-dorso">
            <p class="dorso-titulo">En caso de accidente, comunicarse con:</p>
            <p class="dato"><span>Nombre:</span> {{ miembro.nombreContacto }}</p>
            <p class="dato"><span>Teléfono:</span> {{ miembro.telefonoContacto }}</p>
            <p class="dato"><span>Enfermedades:</span> {{ miembro.enfermedad || 'Ninguna' }}</p>
            <p class="dato"><span>Seguro en:</span> {{ miembro.institucion || 'Sin seguro' }}</p>
            <br />
            <div class="footer-credencial">
                <p class="by-text">{{ eslogan }}</p>
            </div>
        </div>
    </div>
</template>

<script>
import Printd from 'printd'
import Utiles from '../../Servicios/Utiles'
import QRCode from 'qrcode'

export default {
    name: 'CredencialMiembro',
    props: ['matricula', 'miembro'],

    data: function() {
        return {
            nombreGimnasio:   '',
            logoGimnasioUrl:  '',
            telefonoGimnasio: '',
            direccionGimnasio:'',
            eslogan:          '',
            cssText: `
              @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;700;900&display=swap');
              * { box-sizing: border-box; }
              #credencial { display: flex; gap: 12px; padding: 8px; font-family: Roboto, sans-serif; }
              .credencial {
                  padding: 12px; width: 300px; min-height: 400px;
                  border: 2px solid #1706FF; border-radius: 12px;
                  text-align: center;
                  background: linear-gradient(135deg, #e8ecff 0%, #ddeeff 100%);
                  print-color-adjust: exact; -webkit-print-color-adjust: exact;
              }
              .nav { display: flex; align-items: center; gap: 8px; margin-bottom: 8px;
                  background: rgba(23,6,255,0.08); padding: 6px 8px; border-radius: 8px; }
              .nav-logo { flex-shrink: 0; }
              .logo-img { width: 48px; height: 48px; object-fit: contain; border-radius: 6px; }
              .logo-placeholder {
                  width: 48px; height: 48px; background: #1706FF; color: white;
                  border-radius: 6px; display: flex; align-items: center; justify-content: center;
                  font-size: 24px; font-weight: 900;
              }
              .nav-info { text-align: left; }
              .gym-name { font-size: 13px; font-weight: 700; color: #1706FF; display: block; }
              .gym-contact { font-size: 9px; color: #555; margin: 0; }
              .nombre { font-size: 22px; font-weight: 900; color: #1706FF; letter-spacing: -1px; margin: 4px 0 2px; }
              .matricula { font-family: monospace; font-size: 14px; font-weight: 700; color: #666; margin: 0 0 4px; }
              .imagen { width: 80px; height: 80px; border-radius: 50%; margin: 0 auto 6px; display: block; border: 3px solid #1706FF; object-fit: cover; }
              .dato { font-size: 11px; margin: 2px 0; color: #333; text-align: left; padding: 0 8px; }
              .dato span { font-weight: 700; color: #1706FF; }
              .qr-area { margin-top: 8px; display: flex; flex-direction: column; align-items: center; }
              .qr-area canvas { border: 2px solid #1706FF; border-radius: 6px; }
              .qr-label { font-size: 9px; color: #777; margin: 3px 0 0; }
              .credencial-dorso { background: linear-gradient(135deg, #fff8e1 0%, #fff3cd 100%); }
              .dorso-titulo { font-size: 12px; font-weight: 700; color: #d32f2f; margin-bottom: 8px; }
              .footer-credencial { margin-top: 24px; border-top: 1px solid #ccc; padding-top: 8px; }
              .by-text { font-size: 10px; color: #666; margin: 0; }
            `,
        }
    },

    beforeMount: function() {
        var ajustesStr = localStorage.getItem('ajustes')
        if (ajustesStr) {
            try {
                var aj = JSON.parse(ajustesStr)
                this.nombreGimnasio   = aj.nombre    || ''
                this.telefonoGimnasio = aj.telefono  || ''
                this.direccionGimnasio= aj.direccion || ''
                this.eslogan          = aj.eslogan   || ''
                if (aj.logo) this.logoGimnasioUrl = Utiles.generarURL(aj.logo)
            } catch (e) {}
        }
        if (!this.nombreGimnasio)   this.nombreGimnasio   = localStorage.getItem('nombreGimnasio')   || ''
        if (!this.logoGimnasioUrl)  this.logoGimnasioUrl  = Utiles.generarURL(localStorage.getItem('logoGimnasio') || '')
        if (!this.telefonoGimnasio) this.telefonoGimnasio = localStorage.getItem('telefonoGimnasio') || ''
        if (!this.direccionGimnasio)this.direccionGimnasio= localStorage.getItem('direccionGimnasio')|| ''
    },

    mounted: function() {
        this.d = new Printd()
        var self = this
        var contentWindow = this.d.getIFrame().contentWindow
        contentWindow.addEventListener('afterprint', function() {
            self.$emit('impreso', false)
        })
        this.generarQRYImprimir()
    },

    methods: {
        urlImagen: function(img) { return Utiles.generarURL(img) },

        generarQRYImprimir: function() {
            var self     = this
            var matricula= (this.miembro && this.miembro.matricula) ? this.miembro.matricula : 'SIN-ID'
            QRCode.toDataURL(matricula, {
                width: 90, margin: 1,
                color: { dark: '#1706FF', light: '#ffffff' },
                errorCorrectionLevel: 'H',
            }, function(err, dataUrl) {
                if (err) { console.error('QR error', err); return }
                var img = document.getElementById('qr-credencial-img')
                if (img) img.src = dataUrl
                setTimeout(function() { self.imprimir() }, 300)
            })
        },

        imprimir: function() {
            var self = this
            var zona = document.getElementById('credencial')
            setTimeout(function() {
                self.d.print(zona, [self.cssText])
            }, 100)
            this.$emit('impreso', false)
        },
    },
}
</script>

<style scoped>
#credencial { display: flex; gap: 12px; padding: 8px; }
.credencial {
    padding: 12px; width: 300px; min-height: 400px;
    border: 2px solid #1706FF; border-radius: 12px;
    text-align: center; background: linear-gradient(135deg, #e8ecff 0%, #ddeeff 100%);
}
.nav { display: flex; align-items: center; gap: 8px; margin-bottom: 8px;
    background: rgba(23,6,255,0.08); padding: 6px 8px; border-radius: 8px; }
.logo-img { width: 48px; height: 48px; object-fit: contain; border-radius: 6px; }
.logo-placeholder {
    width: 48px; height: 48px; background: #1706FF; color: white;
    border-radius: 6px; display: flex; align-items: center; justify-content: center;
    font-size: 24px; font-weight: 900;
}
.nav-info { text-align: left; }
.gym-name { font-size: 13px; font-weight: 700; color: #1706FF; display: block; }
.gym-contact { font-size: 9px; color: #555; margin: 0; }
.nombre { font-size: 22px; font-weight: 900; color: #1706FF; margin: 4px 0 2px; }
.matricula { font-family: monospace; font-size: 14px; color: #666; margin: 0 0 4px; }
.imagen { width: 80px; height: 80px; border-radius: 50%; margin: 0 auto 6px; display: block; border: 3px solid #1706FF; object-fit: cover; }
.dato { font-size: 11px; margin: 2px 0; text-align: left; padding: 0 8px; }
.dato span { font-weight: 700; color: #1706FF; }
.qr-area { margin-top: 8px; display: flex; flex-direction: column; align-items: center; }
.qr-area canvas { border: 2px solid #1706FF; border-radius: 6px; }
.qr-label { font-size: 9px; color: #777; margin: 3px 0 0; }
.credencial-dorso { background: linear-gradient(135deg, #fff8e1 0%, #fff3cd 100%); }
.footer-credencial { margin-top: 24px; border-top: 1px solid #ccc; padding-top: 8px; }
</style>


// WEBPACK FOOTER //
// src/components/Miembros/CredencialMiembro.vue